export default {
  files: [],
  filesLoading: false,
  currentFile: null,
  currentFileMeta: null,
  metaLoading: false
};
